module.exports = __webpack_public_path__ + "img/1_nyfw_fr.3c6e4877.jpg";